module.exports = __webpack_public_path__ + "static/media/undraw_factory_dy0a.c65546bb.svg";